import { render, staticRenderFns } from "./extract.vue?vue&type=template&id=77a73052"
import script from "./extract.vue?vue&type=script&lang=js"
export * from "./extract.vue?vue&type=script&lang=js"
import style0 from "./extract.vue?vue&type=style&index=0&id=77a73052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports